import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from './constants';

const bookingsService = createApi({
    reducerPath: 'bookingsService',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('admin')
                ? JSON.parse(localStorage.getItem('admin')).token
                : null;
            if (token) headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        fetchBookings: builder.query({
            query: (page = 1) => `admin/get-bookings?page=${page}`,
        }),
        fetchBookingDetails: builder.query({
            query: (id) => `admin/booking-details/${id}`,
        }),

    }),
});

export const { useFetchBookingsQuery, useFetchBookingDetailsQuery } = bookingsService;
export default bookingsService;
